import {gql} from '@apollo/client';
import {CatalogSongComplete} from '../../graphql/CatalogSongCompleteFragment';

export const SEARCH_SONGS_QUERY = gql`
  query searchSongs($search_term: String!, $limit: Int) {
    music {
      searchSongs(searchTerm: $search_term, limit: $limit) {
        ...CatalogSongComplete
      }
    }
  }
  ${CatalogSongComplete.catalogSong}
`;
